import { adminNotificationAnalyticsQueryKeys as e } from "./adminNotificationAnalyticsQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminNotificationsApi as n } from "@maat/api-notifications";
//#region src/notifications/admin/useAdminNotificationAnalyticsSummaryQuery.ts
var r = (r) => t({
	queryKey: e.summary(r),
	queryFn: () => n.getAnalyticsSummary(r)
});
//#endregion
export { r as useAdminNotificationAnalyticsSummaryQuery };
